module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clinic-detail"
  }, [_c('div', [_c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(_vm.notify !== null) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.notify.success, 'alert-danger': _vm.notify.danger, 'alert-warning': _vm.notify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), ('message_i18n' in _vm.notify) ? _c('p', {
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.notify.message_i18n)))]) : _vm._e(), ('message_direct' in _vm.notify) ? _c('p', {
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.notify.message_direct))]) : _vm._e()])])]) : _vm._e()])], 1), _c('div', [_c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goPrev()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Select Clinic')))])]), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Detail')))])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goFacilities()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Facility')))])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goFacilityPersons()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Facility Person')))])]), _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goPrev()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Clinic')))])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goDoctorList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Doctor')))])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goCareOffices()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Office')))])]), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goCareManagers()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Care Manager')))])])])])]), (_vm.loading || !_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(0)]) : _vm._e(), [(_vm.history == null && _vm.searchCallbackFlag) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])])]) : _vm._e(), (!_vm.loading && _vm.history != null) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-offset-3"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.history.clinic_name_furigana))]), _c('h3', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_vm._v(_vm._s(_vm.history.clinic_name))])]), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('history.reference_date')))]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clinicHisId),
      expression: "clinicHisId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        _vm.clinicHisId = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, function($event) {
        _vm.onChangeSelectDate()
      }]
    }
  }, _vm._l((_vm.clinicHistories), function(f) {
    return _c('option', {
      domProps: {
        "value": f.attributes['clinic_history_id']
      }
    }, [_vm._v(_vm._s(_vm.getReferenceDate(f)))])
  }))]), (_vm.history.enable_flag === 0) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('clinic.clinic_disabled')))])])]) : _vm._e()]), _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(1), _c('div', {
    staticClass: "col-xs-9"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_vm._m(2), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('clinic.address')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [_vm._v("〒" + _vm._s(_vm.history.post_no) + " " + _vm._s(_vm.history.address1) + _vm._s(_vm.history.address2))])]), _c('tr', [_vm._m(3), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('clinic.tel')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.history.tel))])]), _c('tr', [_vm._m(4), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('clinic.fax')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.history.fax))])]), _c('tr', [_vm._m(5), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('clinic.email')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.history.email))])]), _c('tr', [_vm._m(6), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('clinic.send_type')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.history.send_type_name)), _c('i', {
    staticClass: "fa fa-clock-o"
  }, [_vm._v(" " + _vm._s(_vm.getSendTimingName(_vm.history.send_timing)))]), (_vm.history.send_timing === 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.getSendTimingHourName(_vm.history.send_timing_hour)) + ")")]) : _vm._e()])]), _c('tr', [_vm._m(7), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('clinic.fusezi')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [(_vm.history.fusezi_flag === 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('clinic.fusezi_msg1')) + _vm._s(_vm.$t('clinic.fusezi_msg2')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('clinic.fusezi_nashi')))])])]), _c('tr', [_vm._m(8), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('clinic.charge_shops')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.history.shop_name_list))])]), _c('tr', [_vm._m(9), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('Login ID')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('clinic.login_id_prefix')) + _vm._s(_vm.clinic.login_id))])]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#email_confirm"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('LoginID Password Notify')))])]), _c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.onPrintNotifyPDF
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('LoginID Password Notify PDF')))])])])])])]), _c('tr', [_vm._m(10), _c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v(_vm._s(_vm.$t('Password')))]), _c('td', {
    staticClass: "col-xs-9"
  }, [_vm._v(_vm._s(_vm.clinic.password))])]), _vm._l((_vm.clinicCodeList), function(clinicCode) {
    return (_vm.clinicCodeList.length > 0) ? _c('tr', [_c('td', {
      class: {
        codelist: clinicCode.id != 0
      }
    }), _c('td', {
      class: {
        codelist: clinicCode.id != 0
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('clinic.clinic_code')))]), _c('span', [_vm._v(_vm._s(clinicCode.clinic_code))])])]) : _vm._e()
  })], 2)])])])]) : _vm._e(), (!_vm.loading && _vm.history != null && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top image-gallery"
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "col-sm-3 text-center image-container"
    }, [(image.del_flag === 0) ? [_c('a', [_c('img', {
      staticClass: "img-thumbnail",
      attrs: {
        "src": image.image_path + '?token=' + _vm.authToken
      },
      on: {
        "click": function($event) {
          _vm.onClickImageModalShow(image)
        }
      }
    })]), _c('div', {
      staticClass: "image-title editable",
      on: {
        "click": function($event) {
          _vm.onClickTitleEditModalShow(image)
        }
      }
    }, [_vm._v(_vm._s(image.title))]), _c('a', {
      staticClass: "button",
      on: {
        "click": function($event) {
          _vm.removeImage(image)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])] : _vm._e()], 2)
  })) : _vm._e(), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(!_vm.loading && _vm.history != null && _vm.searchCallbackFlag) ? [_c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "disabled": !_vm.canAddImage
    },
    on: {
      "click": function($event) {
        _vm.onClickUploadModalShow()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-image-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Image Regist')))])]), _c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('ImageSave')))])]), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Image Description')))])] : _vm._e()], 2)]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "google-maps",
    class: {
      'google-maps-load': _vm.history == null || _vm.loading || !_vm.searchCallbackFlag
    },
    attrs: {
      "id": "map"
    }
  })]), (!_vm.loading && _vm.history != null && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle bg-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Google Logo')))])])]) : _vm._e()])], (!_vm.loading && _vm.history != null && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-8 text-left"
  }, [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.goClinicEdit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Edit')))])]), (_vm.isAdminOrPharmacistManager) ? _c('a', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delete_confirm_modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Delete')))])]) : _vm._e(), (_vm.history.enable_flag !== 0) ? _c('span', [_c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onStop(0)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('clinic.torihiki_stop')))])])]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.onStop(1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('clinic.torihiki_start')))])])])]), _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.goClinicDoctors()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-md"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Doctor')))])]), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.goPrev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])])]) : _vm._e(), (_vm.loading || !_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.goPrev()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Back')))])])])]) : _vm._e(), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete_confirm_modal",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('clinic.modal.delete_confirm')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(11), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('clinic.modal.delete_msg')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onClickDelete()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "email_confirm",
      "role": "dialog",
      "aria-labelledby": "confirmModal",
      "data-name": "",
      "data-param": ""
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t('Close')))])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('clinic.modal.id_pass_notify_confirm')))])]), _c('div', {
    staticClass: "modal-body dialog-confirm"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(12), _c('div', {
    staticClass: "col-sm-9",
    staticStyle: {
      "padding-top": "45px"
    }
  }, [_c('div', {
    staticClass: "form-group form-inline"
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.$t('clinic.modal.id_pass_notify_message')))])])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.onSendMedinfo()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('No')))])])])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(13), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])]), _c('button', {
    ref: "editTitleBtn",
    staticClass: "hide",
    attrs: {
      "id": "edit_title_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#edit_title_modal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit_title_modal",
      "role": "dialog",
      "aria-labelledby": "titleEditModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(14), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "titleEditModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('Image Title Edit')))])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row margin-top-divide"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_vm._v(" " + _vm._s(_vm.$t('Title')))])]), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editImageTitle),
      expression: "editImageTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "title",
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.editImageTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editImageTitle = $event.target.value
      }
    }
  })])])])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.saveTitle()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Save')))]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])]), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "images_upload_modal_button",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#images_upload_modal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "images_upload_modal",
      "role": "dialog",
      "aria-labelledby": "imagesUploadModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(15), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "imageUploadModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('Image Upload')))])]), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    attrs: {
      "id": "image_upload_section"
    }
  }, [_c('div', {
    staticClass: "drop-uploader text-center",
    attrs: {
      "id": "drop",
      "disabled": !_vm.canAddImage
    },
    on: {
      "dragover": _vm.onDragOver,
      "drop": _vm.onDrop
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Image Upload Message')))]), _c('i', {
    staticClass: "fa fa-upload"
  })]), _c('input', {
    attrs: {
      "type": "file",
      "id": "files",
      "disabled": !_vm.canAddImage
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _c('p', [_vm._v(_vm._s(_vm.uploadCounter))]), (_vm.uploadSuccess) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Image Upload Successful')))])]) : _vm._e(), (_vm.uploadErrors && _vm.uploadErrors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, _vm._l((_vm.uploadErrors), function(uploadError) {
    return _c('p', [_vm._v(_vm._s(uploadError))])
  })) : _vm._e()]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3 text-center"
  }, [_c('i', {
    staticClass: "fa fa-hospital-o text-primary fa-5x margin-top"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-home text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-phone text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-fax text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-envelope text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-asterisk text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-medkit text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-key text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa text-primary fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-fw"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "90px"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle fa-fw"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a4661d86!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/clinic-detail.pug
// module id = 408
// module chunks = 1